export default "__VITE_ASSET__D_njryl9__"